// src/components/Countdown.js
import React, { useState, useEffect, useRef } from 'react';

const countdownSequence = [
    { num: '3', text: 'Bersiap...' },
    { num: '2', text: 'Konsentrasi...' },
    { num: '1', text: 'Fokus...' },
    { num: 'Mulai!', text: 'Gasskan!!!', isStart: true }
];

/**
 * Komponen Countdown yang telah diperbaiki untuk menghindari error "update during render".
 * @param {object} props
 * @param {function} props.onFinish - Callback yang dipanggil setelah hitung mundur selesai.
 */
function Countdown({ onFinish }) {
    const [stepIndex, setStepIndex] = useState(0);
    const numberRef = useRef(null);
    const textRef = useRef(null);

    // EFEK 1: Mengelola timer untuk menaikkan state internal (stepIndex).
    useEffect(() => {
        // Hentikan pembuatan interval baru jika hitung mundur sudah selesai.
        if (stepIndex >= countdownSequence.length) {
            return;
        }

        const interval = setInterval(() => {
            setStepIndex(prevIndex => prevIndex + 1);
        }, 1000);

        // Fungsi cleanup: Hapus interval saat komponen di-unmount atau saat stepIndex berubah.
        return () => clearInterval(interval);
    }, [stepIndex]); // Jalankan ulang efek ini setiap kali stepIndex berubah.

    // EFEK 2: Mengelola efek samping (memberi tahu parent) setelah state berubah.
    // Ini adalah perbaikan utamanya.
    useEffect(() => {
        // Jika stepIndex telah melampaui panjang sekuens, panggil onFinish.
        if (stepIndex >= countdownSequence.length) {
            onFinish();
        }
    }, [stepIndex, onFinish]); // Jalankan efek ini saat stepIndex atau onFinish berubah.

    // Efek untuk memicu ulang animasi CSS setiap kali step berubah
    useEffect(() => {
        if (numberRef.current && textRef.current) {
            const elements = [numberRef.current, textRef.current];
            elements.forEach(el => {
                el.style.animation = 'none';
                void el.offsetHeight; // Trik reflow untuk me-reset animasi
                el.style.animation = '';
            });
        }
    }, [stepIndex]);

    // Jika hitung mundur sudah selesai, render null selagi menunggu parent mengganti screen.
    if (stepIndex >= countdownSequence.length) {
        return null;
    }

    const currentStep = countdownSequence[stepIndex];
    const numberClass = `countdown-number ${currentStep.isStart ? 'start' : ''}`;
    const textClass = `countdown-text ${currentStep.isStart ? 'start' : ''}`;

    return (
        <div id="countdownOverlay" className="countdown-overlay" style={{ display: 'flex' }}>
            <div className="countdown-content">
                <div id="countdownNumber" className={numberClass} ref={numberRef}>
                    {currentStep.num}
                </div>
                <div id="countdownText" className={textClass} ref={textRef}>
                    {currentStep.text}
                </div>
            </div>
        </div>
    );
}

export default Countdown;